import { FC, memo } from 'react';
import { useHistory } from 'react-router';
import { useQuery } from '@apollo/client';

import useCurrentLanguage from 'common/hooks/useCurrentLanguage';
import FilePreview from 'components/FilePreview';

import { InvoicePdfUrlDocument } from './graphql/queries/invoicePdfUrl.gql';
import { ReceiptDocument } from './graphql/queries/receipt.gql';

interface LegacyReceiptPreviewProps {
  closeUrl: string;
  transactionId: string;
}

/**
 * @deprecated Replaced by ReceiptPreview
 * @todo Delete after multi-doc feature release
 * @link https://linear.app/shine/issue/CAC-58
 */
const LegacyReceiptPreview: FC<LegacyReceiptPreviewProps> = ({
  closeUrl,
  transactionId,
}) => {
  let url;
  const history = useHistory();
  const currentLanguage = useCurrentLanguage();
  const { data, error } = useQuery(ReceiptDocument, {
    variables: {
      transactionId,
    },
  });

  const { data: pdfUrlData } = useQuery(InvoicePdfUrlDocument, {
    skip: !data?.transaction.invoiceId,
    variables: {
      invoiceId: data?.transaction.invoiceId || '',
    },
  });

  if (error) {
    return <div>Oops! Erreur</div>;
  }

  if (!data || !data.transaction) {
    return null;
  }

  const { invoiceId, receipt } = data.transaction;

  if (!receipt && !invoiceId) {
    throw new Error('No receipt or invoice found');
  }

  if (pdfUrlData?.invoice.pdf) {
    url = pdfUrlData.invoice.pdf[`${currentLanguage}Url`];
  } else if (receipt?.url) {
    url = receipt.url;
  } else {
    return null;
  }

  return (
    <FilePreview
      alt={receipt ? receipt.sellerName : ''}
      onClose={() => {
        history.push(closeUrl);
      }}
      url={url}
    />
  );
};

export default memo(LegacyReceiptPreview);
